import React from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router';

import {TActionButtonOption} from '@edna/components';
import KeyboardArrowDownIcon from '@edna/icons/keyboardArrowDown.svg';

import {ArrowBackIcon, EyeIcon} from 'src/icons';

import {Text} from '../primitives';
import * as S from './style';

type TOption = {
  icon?: TSvgComponentType;
  title: string;
  path: string;
  disabled?: boolean;
};

type TProps = {
  head?: React.ReactNode;
  options: TOption[];
  disabled?: boolean;
};

export const ViewClientPagesButton = React.memo<TProps>(({options, disabled}) => {
  const navigate = useNavigate();
  const {t} = useTranslation();

  const preparedOptions: TActionButtonOption[] = React.useMemo(
    () =>
      options.map((option) => ({
        content: (
          <>
            <S.OptionIcon as={option.icon} />
            {option.title}
          </>
        ),
        handler: () => navigate(option.path),
        props: {disabled: option.disabled},
      })),
    [options],
  );

  return (
    <S.ActionButton options={preparedOptions} disabled={disabled} size="S">
      <EyeIcon />
      {t('Components:viewClientPagesButton.seeAsClient')}
      <KeyboardArrowDownIcon />
    </S.ActionButton>
  );
});

ViewClientPagesButton.displayName = 'ViewClientPagesButton';

export const ClientPageHeader = React.memo<{title?: string; backPath: string}>(
  ({title, backPath}) => {
    const navigate = useNavigate();
    const {t} = useTranslation();

    return (
      <S.Header>
        <S.Button size="S" onClick={() => navigate(backPath)}>
          <ArrowBackIcon />
          {t('Components:viewClientPagesButton.backToProfile')}
        </S.Button>
        <Text weight={500} color="blue500">
          {title}
        </Text>
      </S.Header>
    );
  },
);

ClientPageHeader.displayName = 'ClientPageHeader';
